import Loading from "../Loading/Loading";

import styles from "./GlobalLoader.module.css";



const GlobalLoader = () => {
  return (
    <div className={styles["loader"]}>
      <Loading />
    </div>
  );
};

export default GlobalLoader;
